import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { hasAdminModuleAccess } from "../../../../utils/roleHelper";
import { getFirstAccessibleAdminPath } from "../../../../utils/adminNavigation";

export default function RequireAdminModuleAccess({
  user,
  moduleKey,
  children,
  permissionsLoaded,
}) {
  const location = useLocation();

  if (!permissionsLoaded) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (hasAdminModuleAccess(user, moduleKey, "view")) {
    return children;
  }

  const fallback = getFirstAccessibleAdminPath(user) || "/";

  if (location.pathname !== fallback) {
    return <Navigate to={fallback} replace />;
  }

  return <Navigate to="/" replace />;
}